import { AfterViewInit, ApplicationRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BlockUI, Users, UserState, BlockUIState } from '@harlowe/core';
import { Store } from '@ngxs/store';
import { MenuItem } from 'primeng/api';
import { first } from 'rxjs';
import { environment } from '../environments/environment';
import { UserInterface } from './state/ui/ui-actions';
import { ToastModule } from 'primeng/toast';
import { BlockUIModule } from 'primeng/blockui';
import { UserInterfaceState } from './state/ui/ui-state';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { FormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';
import "reflect-metadata";


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AsyncPipe, MenubarModule, ToastModule, BlockUIModule, MenuModule, AvatarModule, CommonModule, FormsModule, SidebarModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit, AfterViewInit{
  title = '@harlowe/teal_health';

  currentUser$ = this._store.select(UserState.currentUser);
  uiBlocked$ = this._store.select(BlockUIState.uiBlocked); 
  sidebarVisible$ = this._store.select(UserInterfaceState.sidebarVisibility);
  menuVisible$ = this._store.select(UserInterfaceState.topMenuVisibility);

  showMenu = true

  topMenuItems: MenuItem[] = [];
  avatarItems: MenuItem[] = [];

  topMenuSearchValue: string = "";
  rightSidebarVisible: boolean = false;

  constructor
  (
    public _store: Store,
    private _appRef: ApplicationRef,
    private _msal: MsalService,
    private _route: ActivatedRoute,
    private router: Router
  )
  {
   

    this.sidebarVisible$.subscribe(v => this.rightSidebarVisible = v);
    this.menuVisible$.subscribe
    (
      v => 
      {
        this.showMenu = v
      }
    );

    this._appRef.isStable.pipe(first((stable) => stable))
    .subscribe
    (
      () =>
      {
        if (environment.harlowe.tealhealth.autologin)
          this._store.dispatch(new Users.AppLoaded());
      }
    );


    var rc = this.router.events.subscribe
    (
      e => 
        {
          if(e instanceof NavigationStart)
          {
            if(e.url.includes('sidebar'))
              _store.dispatch(new UserInterface.OpenSidebar())
              // this.sidebarVisible = true;
          }
        }
    )

  }
  ngAfterViewInit(): void {
    setTimeout(() => this._store.dispatch(new BlockUI.UnBlockUI()));
  }


  ngOnInit(): void {

    this._route.queryParamMap.subscribe(
      qpm => 
      {
        if(qpm && qpm.get('showMenu'))
        {
          this._store.dispatch(new UserInterface.SetTopMenuVisibility({show: qpm.get('showMenu') === 'true'}))
        }
      }
    )

    this._store.dispatch(new BlockUI.BlockUI());

    this.avatarItems = 
    [
      {
        label: "Logout",
        icon: "pi pi-sign-out",
        command: (event) => this.requestLogout()
      }
    ];

    this.topMenuItems =
    [
      {
        label: 'Home',
        icon: 'pi pi-home',
        command: (event) => {
          this.router.navigate([''], {replaceUrl: true});
        }
      },
      {
        label: 'Providers',
        icon: 'pi pi-building',
        command: () => this.router.navigate(['providers'], {replaceUrl: true})
      },
      {
        label: 'Email Campaigns',
        icon: 'pi pi-envelope',
        command: (event) => {
          this.router.navigate(['/email-campaign-manager']);
        }
      }
    ]
  }


  loadRouteInSidebar(routeName: string)
  {
    this._store.dispatch(new UserInterface.LoadRouteInSidebar({route:routeName}));
  }

  requestLogout()
  {
    this._msal.logoutPopup();
  }

  hideSidebar()
  {
    this._store.dispatch(new UserInterface.CloseSidebar());
  }

}
